import React from 'react';

import styles from './Page.module.scss';

export interface PageProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  hasBackground?: boolean;
}

export const Page = ({
  hasBackground = false,
  children,
  ...props
}: PageProps) => {
  return (
    <div
      {...props}
      className={styles.page}
      data-test-id="page-container"
      data-has-background={hasBackground}
    >
      {children}
    </div>
  );
};
